module.exports = __webpack_public_path__ + "181aea54a334ee3ee967037c87088344.png";